import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/rubik/latin-400.css';
import '@fontsource/rubik/latin-500.css';
import '@fontsource/rubik/latin-700.css';
import '@fontsource/rubik/latin-ext-400.css';
import '@fontsource/rubik/latin-ext-500.css';
import '@fontsource/rubik/latin-ext-700.css';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App';
import './components/ModalTheme.css';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { startNativeSplashFallback } from './services/nativeStartup';
import { watchForAppUpdate } from './services/appUpdate';

startNativeSplashFallback();
watchForAppUpdate();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// Configure status bar for native platforms
if (Capacitor.isNativePlatform()) {
  StatusBar.hide();
}
